// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"fV-z","inlineTitle":"gV-z","sponsoredAdsWrapper":"hV-z","marketplaceRecosWrapper":"iV-z"};